import React from 'react';
import {
  StyledButton,
  StyledButtonsWrapper,
  StyledInput,
  StyledTitle,
  StyledWrapper,
} from './QuantityComponent.style';

export default function QuantityComponent(props) {
  const {
    style: { body, button, title },
    label,
    maxQuantity,
    minQuantity,
    onClickNextButton,
    onClickPrevButton,
    onQuantityChange,
    quantity,
    width = '100%',
    allowManualEntry = false,
  } = props;

  const buttonStyles = {
    ...title,
    borderColor: button.backgroundColor,
    color: body.color,
    backgroundColor: body.backgroundColor,
  };

  const handleManualInput = (event) => {
    if (!allowManualEntry || !onQuantityChange) return;

    const rawValue = event.target.value;

    // Allow empty input for better UX (user is clearing to type new value)
    if (rawValue === '') {
      onQuantityChange(''); // Pass empty string to parent to allow visual clearing
      return;
    }

    const value = parseInt(rawValue, 10);
    if (Number.isNaN(value)) return; // Ignore invalid characters

    let newQuantity = value;

    // Apply minimum quantity constraint
    if (typeof minQuantity === 'number' && newQuantity < minQuantity) {
      newQuantity = minQuantity;
    }

    // Apply maximum quantity constraint
    if (typeof maxQuantity === 'number' && newQuantity > maxQuantity) {
      newQuantity = maxQuantity;
    }

    onQuantityChange(newQuantity);
  };

  const handleInputBlur = (event) => {
    if (!allowManualEntry || !onQuantityChange) return;

    const rawValue = event.target.value;

    // If input is empty when user finishes, default to minimum quantity
    if (rawValue === '' || Number.isNaN(parseInt(rawValue, 10))) {
      const defaultQuantity = typeof minQuantity === 'number' ? minQuantity : 1;
      onQuantityChange(defaultQuantity);
    }
  };

  return (
    <StyledWrapper style={{ width }}>
      {label && (
        <StyledTitle style={body}>
          {label}
        </StyledTitle>
      )}

      <StyledButtonsWrapper data-testid="quantity-input">
        <StyledButton
          aria-label="decrease"
          type="button"
          onClick={onClickPrevButton}
          customStyles={buttonStyles}
          disabled={quantity <= minQuantity}
        />

        <StyledInput
          name="Quantity"
          type={allowManualEntry ? 'number' : 'text'}
          value={quantity}
          style={{ ...body, ...{ borderColor: body.backgroundColor } }}
          readOnly={!allowManualEntry}
          onChange={handleManualInput}
          onBlur={handleInputBlur}
          min={minQuantity}
          max={maxQuantity}
        />

        <StyledButton
          aria-label="increase"
          data-testid="quantity-increase-button"
          type="button"
          onClick={onClickNextButton}
          customStyles={buttonStyles}
          disabled={quantity >= maxQuantity}
        />
      </StyledButtonsWrapper>
    </StyledWrapper>
  );
}
